import React from 'react';

const DEFAULT_BUCKETS = [
  { key: 'food_supplies', label: 'Food & supplies', percentage: 60, color: '#BA1826' },
  { key: 'hygiene_essentials', label: 'Hygiene essentials', percentage: 30, color: '#FCA5A5' },
  { key: 'distribution', label: 'Distribution', percentage: 10, color: '#FECACA' },
];

export const FundAllocationChart = ({ allocation }) => {
  const buckets = allocation?.buckets || DEFAULT_BUCKETS;

  let cumulative = 0;
  const stops = buckets.map((b) => {
    const start = cumulative;
    cumulative += b.percentage;
    return `${b.color} ${start}% ${cumulative}%`;
  });
  const gradient = `conic-gradient(${stops.join(', ')})`;

  return (
    <section className="py-10 bg-[#F8F9FA] border-t border-[#E5E7EB]" data-testid="breakdown-section">
      <div className="px-6">
        <div className="max-w-md mx-auto text-center">
          <h3 className="font-heading text-lg font-semibold text-[#0A0A0A] mb-4">
            Where Your Donation Goes
          </h3>
          <div className="flex justify-center mb-4">
            <div
              className="w-32 h-32 rounded-full transition-all duration-500"
              style={{ background: gradient }}
              data-testid="allocation-pie-chart"
            />
          </div>
          <div className="space-y-2 text-sm" data-testid="allocation-labels">
            {buckets.map((b) => (
              <div key={b.key} className="flex items-center justify-center gap-3">
                <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: b.color }} />
                <span className="text-[#4B5563]">
                  <strong>{b.percentage}%</strong> &mdash; {b.label}
                  {allocation?.has_data && b.amount > 0 && (
                    <span className="text-[#9CA3AF] ml-1">(${b.amount.toLocaleString()})</span>
                  )}
                </span>
              </div>
            ))}
          </div>
          <p className="text-[10px] text-[#9CA3AF] mt-3" data-testid="allocation-source-note">
            {allocation?.has_data
              ? `Based on $${allocation.total_expenses.toLocaleString()} in tracked expenditures`
              : 'Data updating soon \u2014 based on projected allocation targets'}
          </p>
        </div>
      </div>
    </section>
  );
};
